import { Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-edit-regular-manual-rostering',
  templateUrl: './edit-regular-manual-rostering.component.html',
  styleUrls: ['./edit-regular-manual-rostering.component.css']
})
export class EditRegularManualRosteringComponent implements OnInit {
  constructor(){}
  ngOnInit(){}
}